// Helper function to format price with currency symbol
export const formatPrice = (price, currency) => {
  if (!price || price === 0) {
    return 'POA';
  }

  const currencySymbols = {
    USD: '$',
    GBP: '£',
    EUR: '€',
  };

  const symbol = currencySymbols[currency] || '$';
  const formattedNumber = price.toLocaleString('en-US');
  
  return `${symbol}${formattedNumber}`;
};

// Helper to get currency symbol
export const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: '$',
    GBP: '£',
    EUR: '€',
  };
  return symbols[currency] || '$';
};